import React, { useState } from 'react';
import styled from 'styled-components';

import Tabs from 'antd/es/tabs';

const PeriodFilterTabs = styled(Tabs)`
  & .ant-tabs-nav {
    margin-bottom: 0;
    margin-top: -2px;

    & .ant-tabs-tab {
      padding: 10px 0;
    }
  }

  & .ant-tabs-nav::before {
    border-bottom: none;
  }

  & .ant-tabs-content-holder {
    display: none;
  }
`;

const defaultPeriods = [
  { title: 'Daily', value: 'daily' },
  { title: 'Weekly', value: 'weekly' },
  { title: 'Monthly', value: 'monthly' },
  { title: 'Yearly', value: 'yearly' },
];

const PeriodFilter = ({ selectedPeriod, options, exclude, ...props }) => {
  const [periods] = useState(() => {
    let periods = options && options.length ? options : [...defaultPeriods];
    if (Array.isArray(exclude)) {
      periods = periods.filter(p => !exclude.includes(p.value));
    }
    return periods;
  });

  return (
    <PeriodFilterTabs activeKey={selectedPeriod} {...props}>
      {
        periods.map(period => (
          <Tabs.TabPane key={period.value} tab={period.title} />
        ))
      }
    </PeriodFilterTabs>
  );
};

export default PeriodFilter;
